import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useStyles, StyleSheet, padding, transition } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { useNavigation } from '../context';
import { WIDTHS } from '../utils/constants';
import { Button } from './button';
var ChevronRight = Icons.ChevronRight;
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    cursor: 'pointer'
  }, padding.styles({
    target: 'navigation.menu.expander',
    all: function all() {
      return '2.2rem';
    }
  })), {}, {
    color: function color(_ref) {
      var token = _ref.token;
      return token('navigation.menu.expander.color', token('palette.white'));
    },
    height: function height(_ref2) {
      var token = _ref2.token;
      return token('navigation.menu.expander', WIDTHS.MENU.DESKTOP);
    },
    backgroundColor: function backgroundColor(_ref3) {
      var token = _ref3.token;
      return token('navigation.menu.expander', token('color.container.static.primary.contrast'));
    }
  }),
  icon: _objectSpread({}, transition.styles({
    target: 'navigation.menu.expander',
    property: 'transform',
    duration: 'medium',
    easing: 'smooth'
  })),
  expanded: {
    transform: 'rotate(180deg)'
  }
});
export function Expander() {
  var s = useStyles(defaultStyles);

  var _useNavigation = useNavigation(),
      isExpanded = _useNavigation.isExpanded,
      setActiveItem = _useNavigation.setActiveItem,
      setIsExpanded = _useNavigation.setIsExpanded;

  return /*#__PURE__*/React.createElement(Button, _extends({}, s('container'), {
    onClick: function onClick() {
      setIsExpanded(function (isExpanded) {
        return !isExpanded;
      });
      setActiveItem(null);
    }
  }), /*#__PURE__*/React.createElement(ChevronRight, _extends({}, s({
    expanded: isExpanded
  }), {
    size: "m"
  })));
}